import styled from 'styled-components';

import Box from 'components/Box';

export const MessageContainer = styled(Box)`
  a {
    color: currentcolor;
  }
`;
